module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "mogos_main"
  }, [_c('div', {
    staticClass: "mogos_main_page"
  }, [_c('div', {
    ref: "mybox",
    staticClass: "detail_slide_1"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "40%",
      "left": "0",
      "right": "0",
      "bottom": "0"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "24"
    }
  }, [_c('img', {
    staticClass: "mogos-logo",
    attrs: {
      "src": require("../../assets/store/mogos_logo.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "details_banner_text"
  }, [_vm._v("\n                            任你飞全球，无限流量享自由\n                        ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout-content",
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('div', {
    staticClass: "Product-content mogos"
  }, [_c('div', {
    staticClass: "Product-content",
    staticStyle: {
      "background": "#FFFFFF",
      "padding": "10% 0 10% 0"
    }
  }, [_c('Row', {
    staticStyle: {
      "padding": "0 3% 0 3%"
    }
  }, [_c('Col', {
    staticClass: "Product-left",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "md": 13
    }
  }, [_c('img', {
    staticClass: "mogos-logo",
    attrs: {
      "src": require("../../assets/store/mogos_card.png")
    }
  })]), _vm._v(" "), _c('Col', {
    staticClass: "Product-right",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": 11
    }
  }, [_c('p', {
    staticClass: "Product-name"
  }, [_vm._v("\n                                MOGO S\n                            ")]), _vm._v(" "), _c('p', {
    staticClass: "Product-price"
  }, [_vm._v("\n                                $" + _vm._s(_vm.goods_info.goods_price) + "\n                            ")]), _vm._v(" "), _c('p', {
    staticClass: "Product-details"
  }, [_vm._v("\n                                MOGO S是一张连接全球通讯的上网卡，覆盖超过200个国家。以优秀的移动数据资源为全球旅客提供稳定快速的网络，保证旅途中每一个联系的便捷性。零漫游的技术使用户随时随地都连接到当地的3G／4G网络，更低的当地资费为用户节省了大量的通讯费用。从此，跨境通讯将和本地无异。\n                            ")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Product-details-li"
  }, [_vm._v("使用当地网络，为您节省95%的通讯费")]), _vm._v(" "), _c('li', {
    staticClass: "Product-details-li"
  }, [_vm._v("插卡即联网，操作简单便捷")]), _vm._v(" "), _c('li', {
    staticClass: "Product-details-li"
  }, [_vm._v("线上续购套餐，无需登记等待")])]), _vm._v(" "), _c('buy', {
    attrs: {
      "id": parseInt(_vm.$route.params.id),
      "maxCount": parseInt(_vm.goods_info.store_count)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "Product-content speedy"
  }, [_c('div', {
    staticStyle: {
      "background": "rgba(31,45,61,0.3)",
      "padding": "20px 0 20px 0"
    }
  }, [_c('Row', [_c('p', {
    staticClass: "Product-tips"
  }, [_vm._v("\n                                    一卡在手，便捷随行\n                                ")])]), _vm._v(" "), _c('Row', {
    staticClass: "details-card",
    attrs: {
      "gutter": 30
    }
  }, [_c('Col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/mogos_icon1.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("零漫游 :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("在全球都是连接"), _c('br'), _vm._v("当地的网络")])])])], 1), _vm._v(" "), _c('Col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/mogos_icon2.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("零月租 :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("随时需要"), _c('br'), _vm._v("随时启用")])])])], 1), _vm._v(" "), _c('Col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/mogos_icon3.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("低资费 :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("用当地费率"), _c('br'), _vm._v("计费便宜不超支")])])])], 1), _vm._v(" "), _c('i-col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/mogos_icon4.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("国家多 :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("一卡覆盖全球"), _c('br'), _vm._v("200+国家")])])])], 1), _vm._v(" "), _c('i-col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/mogos_icon5.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(" 省时间 :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("在iAPP就搞定"), _c('br'), _vm._v("所有上网功能")])])])], 1), _vm._v(" "), _c('i-col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/mogos_icon6.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(" 服务好:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("24小时的"), _c('br'), _vm._v("客户服务支持")])])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "details_iapp_banner"
  }, [_c('i-col', {
    attrs: {
      "span": "24"
    }
  }, [_c('div', {
    staticClass: "layout-conten",
    staticStyle: {
      "height": "800px",
      "background": "#FFF"
    }
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('i-col', {
    staticStyle: {
      "position": "absolute",
      "top": "0"
    },
    attrs: {
      "xs": 24,
      "sm": {
        span: 12,
        offset: 12
      },
      "md": {
        span: 12,
        offset: 11
      },
      "lg": {
        span: 12,
        offset: 11
      }
    }
  }, [_c('p', {
    staticClass: "details_iapp_text details_iapp_text1"
  }, [_vm._v("\n                                            3步快速联网\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "details_iapp_text details_iapp_text2"
  }, [_vm._v("\n                                            SIM卡 + 流量套餐\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide slider1",
    staticStyle: {
      "position": "relative"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide slider2"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide slider3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12",
      "offset": "12"
    }
  }, [_c('p', {
    staticClass: "details_iapp_text",
    staticStyle: {
      "font-size": "40px",
      "color": "#1F2D3D",
      "line-height": "78px"
    }
  }, [_vm._v("\n                                            3步快速联网\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "details_iapp_text",
    staticStyle: {
      "font-size": "22px",
      "color": "#5E6D82",
      "line-height": "40px"
    }
  }, [_vm._v("\n                                            SIM卡 + 流量套餐\n                                        ")])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "Product-content"
  }, [_c('Row', {
    staticStyle: {
      "padding": "0 3% 0 3%"
    }
  }, [_c('i-col', {
    staticClass: "Product-right",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "md": 24
    }
  }, [_c('p', {
    staticClass: "Product-name"
  }, [_vm._v("\n                                    覆盖全球200+国家\n                                ")])]), _vm._v(" "), _c('Row', {
    staticClass: "detail_country"
  }, [_c('i-col', {
    staticClass: "detail-button",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('i-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": "24"
    }
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('Button', {
      key: index,
      staticClass: "details_global",
      class: {
        details_global_active: index == _vm.num
      },
      on: {
        "click": function($event) {
          _vm.tab(index)
        }
      }
    }, [_vm._v(_vm._s(item) + "\n                                        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "tabCon",
    staticStyle: {
      "width": "80%",
      "margin": "20px auto",
      "font-size": "16px",
      "color": "#5E6D82",
      "line-height": "24px"
    }
  }, _vm._l((_vm.tabContents), function(itemCon, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == _vm.num),
        expression: " index == num"
      }]
    }, [_vm._v(_vm._s(itemCon))])
  }))], 1), _vm._v(" "), _c('i-col', {
    staticClass: "detail-content",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 18,
      "lg": 18
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "6%",
      "width": "80%"
    },
    attrs: {
      "src": require("../../assets/store/map.png")
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "Product-content detials_purchase",
    staticStyle: {
      "padding": "10% 3% 10% 10%"
    }
  }, [_c('Row', [_c('i-col', {
    staticClass: "Product-right",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": 9
    }
  }, [_c('p', {
    staticClass: "Product-name",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("\n                                    畅想飞速上网体验\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "Product-details",
    staticStyle: {
      "color": "#fff",
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v("此处应有文案此处应有文案此处应有文案")]), _vm._v(" "), _c('p', [_vm._v("此处应有文案")])]), _vm._v(" "), _c('button', {
    staticClass: "Product-btn",
    staticStyle: {
      "color": "#fff",
      "background-color": "#0084ff"
    },
    on: {
      "click": _vm.buyNow
    }
  }, [_vm._v("\n                                    马上购买\n                                ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-basis max_width"
  }, [_c('guess')], 1)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-272dd3d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetails/ProductDetails.vue
// module id = 796
// module chunks = 0